
export default function () {

    // 画像
    $('a.js-imagepop').magnificPopup({
        preloader: true,
        type: 'image'
    });

    // ギャラリー
    $('a.js-gallerypop').magnificPopup({
        preloader: true,
        type: 'image',
        gallery: {
            enabled: true
        }
    });


    // youtube用ポップアップ
    $('a.js-youtube').magnificPopup({
        // disableOn: 700,
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        type: 'iframe',
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
                }
            }
        }
    });


    // 外部ソース
    $('a.js-ajaxpop').magnificPopup({
        // disableOn: 700,
        mainClass: 'c-mfp-ajaxpop',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        closeBtnInside: false,
        closeMarkup: '<button title="%title%" type="button" ' +
        'class="mfp-close c-mfp-close"><span></span><span></span></button>',
        type: 'ajax',
        callbacks: {
            ajaxContentAdded: () => {
                $('img.js-lazy').lazyload({ effect: 'fadeIn' });
                $('.c-mfp-ajaxpop__content').perfectScrollbar();
            }
        }
    });



    // iframeを使用
    $('a.js-iframepop').magnificPopup({
        disableOn: 800,
        mainClass: 'c-mfp-ajaxpop',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        closeBtnInside: false,
        closeMarkup: '<button title="%title%" type="button" ' +
        'class="mfp-close c-mfp-close"><span></span><span></span></button>',
        type: 'iframe',
        // callbacks:{
        //     ajaxContentAdded: function(){
        //         $('img.js-lazy').lazyload({effect:'fadeIn'});
        //         $('.c-mfp-ajaxpop__content').perfectScrollbar();
        //     }
        // }
        iframe: {
            // patterns: {
            //     youtube: {
            //         index: 'youtube.com',
            //         id: 'v=',
            //         src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
            //     }
            // }
        }
    });

}




// WEBPACK FOOTER //
// ./js/module/popup.js